
import {fetchUsersByCustomFilters,fetchReportingManagerInfo} from 'api/user'
import {  setSelectedData } from "redux/formDisplay";
import { updateDataAndStatusById } from "api/dashboardDetail";
import { findAndUpdateArray } from "helper/common";
import {
  setDashboardState,
} from "redux/dashboardReducer";
import { userInfo } from 'redux/userInfo';


export let assignPoc = async (params,dispatch,dashboardTableListingData,setDashboardTableListingData,setInternalPOCUpdatedSuccessfully) => {
  try{
    if(params?.customKeys){
    const response = await dispatch(fetchUsersByCustomFilters(params?.customKeys)).unwrap();
    const userInfo = response?.userInfo ?? [];
    await dispatch(setSelectedData({ key: "assign_to", value: userInfo }));
    if (response?.userInfo?.length) {
      if (userInfo.length === 1) {
        const user = userInfo[0];
         dispatch(setSelectedData({ key: "internal_poc_name", value: user?.full_name }));
         dispatch(setSelectedData({ key: "internal_poc_user_id", value: user?.user_id }));
         dispatch(setSelectedData({ key: "internal_poc_email_id", value: user?.email}));
         dispatch(setSelectedData({ key: "internal_poc_mobile_number", value: user?.mobile_number }));
        
      }
      if (params?.hierarchy_required && eval(params?.hierarchy_required && !params?.dashboard_listing_assign)){
      const paramObj = {
        users : response?.users,
        workflowId: params?.workflowId,
        fetchReportingManager:params?.fetchReportingManager
      };
      let res = await fetchReportingManagerInfo(paramObj);
      if(res?.data?.show_application_to){
        await dispatch(setSelectedData({ key: "show_application_to", value: res?.data?.show_application_to }));
      }
       !params?.dashboard_listing_assign && setInternalPOCUpdatedSuccessfully(true)      
    }
    } else {
      // Reset workflow internal POC data if no user found
         dispatch(setSelectedData({ key: "internal_poc_name", value: null }));
         dispatch(setSelectedData({ key: "internal_poc_user_id", value: null }));
         dispatch(setSelectedData({ key: "internal_poc_email_id", value: null}));
         dispatch(setSelectedData({ key: "internal_poc_mobile_number", value:null }));
         dispatch(setSelectedData({ key: "show_application_to", value: [] }));
    }
     
  return {
    status :"success",
    message :"Poc assigned successfully"
  }
}
  }catch(error){
   return{
    status : "failure",
    message :error
   }
  }

}

const updateWorkflow = (body, dashboardTableListingData, setDashboardTableListingData, dispatch) => {
    dispatch(updateDataAndStatusById(body))
      .unwrap()
      .then((res) => {
        const listArray = findAndUpdateArray(
          dashboardTableListingData,
          { key: "workflow_id", value: body?.userId },
          [
            {
              key: "internal_poc",
              value:
                res?.updateInfo?.source_data?.internal_poc_name ||
                res?.updateInfo?.source_data?.internal_poc?.name,
            },
          ]
        );
        dispatch(
          setDashboardState({ key: "dashboardListingData", value: listArray })
        );
        setDashboardTableListingData(listArray);
      });
  };



  
  
